module.exports = __webpack_public_path__ + "static/media/homeowner-screening-1.21d3a51e.png";